import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/UpgradeProfileModal.css";

const UpgradeProfileModal = ({ isOpen, onClose, userid,  userData,setUserData, backendUrl }) => {
  const [activeTab, setActiveTab] = useState("profile");
  const [errors, setErrors] = useState({});
  const [cancelHover, setCancelHover] = useState(false);
  const [saveHover, setSaveHover] = useState(false);

  const [formData, setFormData] = useState({
    username: "",
    name: "",
    emailId: "",
    mobile: "",
    alterMobileNo: "",
    userid: "",
  });

  //  password

  const [passwordData, setPasswordData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [showPassword, setShowPassword] = useState({
    current: false,
    new: false,
    confirm: false,
  });
  const [passwordErrors, setPasswordErrors] = useState({});

  const validatePassword = () => {
    const errors = {};

    const passwordRegex =
  /^(?=\S{8,}$)(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&^#()_\-+=])[A-Za-z\d@$!%*?&^#()_\-+=]+$/;

    if (!passwordData.currentPassword) {
      errors.currentPassword = "Current password is required";
    }

    if (!passwordData.newPassword) {
      errors.newPassword = "New password is required";
    } else if (!passwordRegex.test(passwordData.newPassword)) {
      errors.newPassword =
        "Password must contain 8+ chars, uppercase, lowercase, number and special character";
    }

    if (
      passwordData.currentPassword &&
      passwordData.newPassword &&
      passwordData.currentPassword === passwordData.newPassword
    ) {
      errors.newPassword =
        "New password cannot be the same as current password";
    }

    if (!passwordData.confirmPassword) {
      errors.confirmPassword = "Confirm password is required";
    } else if (passwordData.newPassword !== passwordData.confirmPassword) {
      errors.confirmPassword = "Passwords do not match";
    }

    setPasswordErrors(errors);

    return Object.keys(errors).length === 0;
  };

  const changePassword = async () => {
    if (!validatePassword()) return;

    try {
      const response = await axios.post(`${backendUrl}changePassword`, {
        userid: formData.userid,
        currentPassword: passwordData.currentPassword,
        newPassword: passwordData.newPassword,
      });

      if (response.data.success) {
        alert(response.data.message);

        setPasswordData({
          currentPassword: "",
          newPassword: "",
          confirmPassword: "",
        });

        onClose();
      } else {
        alert(response.data.message);
      }
    } catch (error) {
      alert(error?.response?.data?.message || "Failed to change password");
    }
  };

  const validateForm = () => {
    const newErrors = {};

    // Name mandatory
    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }

    // Email optional but must be valid if entered
    if (
      formData.emailId &&
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.emailId)
    ) {
      newErrors.emailId = "Please enter a valid email address";
    }

    // Mobile optional but must be 10 digits if entered
    if (formData.mobile && !/^[0-9]{10}$/.test(formData.mobile)) {
      newErrors.mobile = "Mobile number must be exactly 10 digits";
    }

    // Alternate mobile optional but must be 10 digits if entered
    if (formData.alterMobileNo && !/^[0-9]{10}$/.test(formData.alterMobileNo)) {
      newErrors.alterMobileNo =
        "Alternate mobile number must be exactly 10 digits";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = async () => {
    if (!validateForm()) {
      return;
    }
    try {
      const response = await axios.post(`${backendUrl}userProfileUpdate`, {
        userid: formData.userid,
        name: formData.name,
        emailId: formData.emailId,
        mobileNo: formData.mobile,
        alterMobileNo: formData.alterMobileNo,
      });

      // console.log("Full Response:", response);
      // console.log("Response Data:", response.data);

      const data = response.data;

      if (data.success === true) {
        alert(data.message || "Profile updated successfully");

        onClose();
      } else {
        alert(data.message || "Failed to update profile");
      }
    } catch (error) {
      console.log("Error Response:", error.response);

      alert(
        error?.response?.data?.message ||
          error?.message ||
          "Server error. Please try again.",
      );
    }
  };

  const handleUpgradeProfile = async () => {
    try {
      const response = await axios.get(`${backendUrl}userDetail`, {
        params: {
          userid: userid,
        },
      });

      if (response.data.success) {
        const data = response.data.user;
        setFormData({
          username: data.username || "",
          name: data.name || "",
          emailId: data.emailId || "",
          mobile: data.mobileNo || "",
          alterMobileNo: data.alterMobileNo || "",
          userid: data.userid || userid,
        });
          setUserData(prev => ({
            ...prev,
            name: formData.name
          }));      
        }
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };

  useEffect(() => {
    handleUpgradeProfile();
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <>
      <div
        className="modal d-block border-0"
        style={{
          background: "rgba(0,0,0,.9)",
          zIndex: 999999, // Modal above everything
        }}
      >
        <div
          className="modal-dialog modal-xl modal-dialog-centered "
          style={{
            maxWidth: "700px",
            zIndex: 1000000, // Modal above everything
          }}
        >
          <div
            className="modal-content"
            style={{
              minHeight: "500px",
              border: "none",
            }}
          >
            {/* Header */}

            <div className="modal-header bg-primary text-white position-relative">
              <div>
                <h4 className="mb-0">Upgrade Profile</h4>
                <small>Welcome {formData.username}</small>
              </div>

              <i className="bi bi-x-lg modal-close-icon" onClick={onClose}></i>
            </div>

            {/* Body */}
            <div className="modal-body p-0">
              <div className="row g-0">
                {/* Sidebar */}
                <div className="col-md-4 border-end bg-light">
                  <div className="nav flex-column nav-pills p-1">
                    <button
                      type="button"
                      className={`nav-link text-start mb-2 ${
                        activeTab === "profile" ? "active" : "text-dark"
                      }`}
                      onClick={() => setActiveTab("profile")}
                    >
                      <i className="bi bi-person me-2"></i>
                      Personal Information
                    </button>

                    <button
                      type="button"
                      className={`nav-link text-start ${
                        activeTab === "password" ? "active" : "text-dark"
                      }`}
                      onClick={() => setActiveTab("password")}
                    >
                      <i className="bi bi-lock me-2"></i>
                      Change Password
                    </button>
                  </div>
                </div>

                {/* Content */}
                <div className="col-lg-8 p-4">
                  {activeTab === "profile" && (
                    <>
                      <div className="row g-3">
                        {/* Full Name */}
                        <div>
                          <label className="form-label fw-semibold">
                            Full Name <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            name="name"
                            className={`form-control ${errors.name ? "is-invalid" : ""}`}
                            value={formData.name}
                            onChange={handleChange}
                            placeholder="Enter Full Name"
                          />

                          {errors.name && (
                            <small className="text-danger">{errors.name}</small>
                          )}
                        </div>

                        {/* Email */}
                        <div>
                          <label className="form-label fw-semibold">
                            Email ID
                          </label>
                          <input
                            type="email"
                            value={formData.emailId}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                emailId: e.target.value,
                              })
                            }
                            className={`form-control ${errors.emailId ? "is-invalid" : ""}`}
                            placeholder="Enter Email ID"
                            spellCheck={false}
                          />

                          {errors.emailId && (
                            <small className="text-danger">
                              {errors.emailId}
                            </small>
                          )}
                        </div>

                        {/* Mobile Number */}
                        <div>
                          <label className="form-label fw-semibold">
                            Mobile Number
                          </label>
                          <input
                            type="text"
                            name="mobile"
                            className={`form-control ${errors.mobile ? "is-invalid" : ""}`}
                            value={formData.mobile}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                mobile: e.target.value
                                  .replace(/\D/g, "")
                                  .slice(0, 10),
                              })
                            }
                            placeholder="Enter Mobile Number"
                          />

                          {errors.mobile && (
                            <small className="text-danger">
                              {errors.mobile}
                            </small>
                          )}
                        </div>

                        {/* Alternate Mobile Number */}
                        <div>
                          <label className="form-label fw-semibold">
                            Alternate Mobile Number
                          </label>
                          <input
                            type="text"
                            value={formData.alterMobileNo}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                alterMobileNo: e.target.value
                                  .replace(/\D/g, "")
                                  .slice(0, 10),
                              })
                            }
                            className={`form-control ${
                              errors.alterMobileNo ? "is-invalid" : ""
                            }`}
                            placeholder="Enter Alternate Mobile Number"
                          />

                          {errors.alterMobileNo && (
                            <small className="text-danger">
                              {errors.alterMobileNo}
                            </small>
                          )}
                        </div>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          gap: "10px",
                          marginTop: "20px",
                          paddingTop: "15px",
                          borderTop: "1px solid #dee2e6",
                          width: "100%",
                        }}
                      >
                        <button
                          type="button"
                          onClick={handleSave}
                          onMouseEnter={() => setSaveHover(true)}
                          onMouseLeave={() => setSaveHover(false)}
                          style={{
                            backgroundColor: saveHover ? "#157347" : "#198754",
                            color: "#fff",
                            border: "1px solid #198754",
                            padding: "8px 20px",
                            borderRadius: "6px",
                            fontSize: "14px",
                            fontWeight: "500",
                            cursor: "pointer",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            minWidth: "120px",
                            transition: "all 0.2s ease-in-out",
                            boxShadow: saveHover
                              ? "0 4px 8px rgba(25, 135, 84, 0.25)"
                              : "0 2px 4px rgba(0, 0, 0, 0.08)",
                            transform: saveHover
                              ? "translateY(-1px)"
                              : "translateY(0)",
                          }}
                        >
                          Save Changes
                        </button>

                        <button
                          type="button"
                          onClick={onClose}
                          onMouseEnter={() => setCancelHover(true)}
                          onMouseLeave={() => setCancelHover(false)}
                          style={{
                            backgroundColor: cancelHover
                              ? "#5c636a"
                              : "#6c757d",
                            color: "#fff",
                            border: "1px solid #6c757d",
                            padding: "8px 20px",
                            borderRadius: "6px",
                            fontSize: "14px",
                            fontWeight: "500",
                            cursor: "pointer",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            minWidth: "100px",
                            transition: "all 0.2s ease-in-out",
                            boxShadow: cancelHover
                              ? "0 4px 8px rgba(0,0,0,0.15)"
                              : "0 2px 4px rgba(0,0,0,0.08)",
                            transform: cancelHover
                              ? "translateY(-1px)"
                              : "translateY(0)",
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    </>
                  )}

                  {activeTab === "password" && (
                    <>
                      <div className="card bg-opacity-10">
                        <div className="card-body">
                          <div className="row g-3">
                            {/* Current Password */}

                            <div>
                              <label className="form-label fw-semibold">
                                Current Password{" "}
                                <span className="text-danger">*</span>
                              </label>

                              <div className="position-relative">
                                <input
                                  type={
                                    showPassword.current ? "text" : "password"
                                  }
                                  className={`form-control ${
                                    passwordErrors.currentPassword
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  value={passwordData.currentPassword}
                                  onChange={(e) =>
                                    setPasswordData({
                                      ...passwordData,
                                      currentPassword:  e.target.value.replace(/\s/g, ""),
                                    })
                                  }
                                  placeholder="Enter Current Password"
                                  style={{ paddingRight: "45px" }}
                                />

                                <i
                                  className={`bi ${
                                    showPassword.current
                                      ? "bi-eye-slash-fill"
                                      : "bi-eye-fill"
                                  }`}
                                  onClick={() =>
                                    setShowPassword((prev) => ({
                                      ...prev,
                                      current: !prev.current,
                                    }))
                                  }
                                  style={{
                                    position: "absolute",
                                    right: "15px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    cursor: "pointer",
                                    color: "#6c757d",
                                    fontSize: "18px",
                                  }}
                                ></i>
                              </div>

                              {passwordErrors.currentPassword && (
                                <small className="text-danger">
                                  {passwordErrors.currentPassword}
                                </small>
                              )}
                            </div>

                            {/* New Password */}
                            <div>
                              <label className="form-label fw-semibold">
                                New Password{" "}
                                <span className="text-danger">*</span>
                              </label>

                              <div className="position-relative">
                                <input
                                  type={showPassword.new ? "text" : "password"}
                                  className={`form-control ${
                                    passwordErrors.newPassword
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  value={passwordData.newPassword}
                                  onChange={(e) =>
                                    setPasswordData({
                                      ...passwordData,
                                      newPassword:  e.target.value.replace(/\s/g, ""),
                                    })
                                  }
                                  placeholder="Enter New Password"
                                  style={{ paddingRight: "45px" }}
                                />

                                <i
                                  className={`bi ${
                                    showPassword.new
                                      ? "bi-eye-slash-fill"
                                      : "bi-eye-fill"
                                  }`}
                                  onClick={() =>
                                    setShowPassword((prev) => ({
                                      ...prev,
                                      new: !prev.new,
                                    }))
                                  }
                                  style={{
                                    position: "absolute",
                                    right: "15px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    cursor: "pointer",
                                    color: "#6c757d",
                                    fontSize: "18px",
                                  }}
                                ></i>
                              </div>

                              <small className="text-muted">
                                Minimum 8 characters with uppercase, lowercase,
                                number and special character.
                              </small>

                              {passwordErrors.newPassword && (
                                <div>
                                  <small className="text-danger">
                                    {passwordErrors.newPassword}
                                  </small>
                                </div>
                              )}
                            </div>

                            {/* Confirm New Password */}
                            {/* <div>
                              <label className="form-label fw-semibold">
                                Confirm New Password{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="password"
                                className="form-control"
                                placeholder="Confirm New Password"
                                autoComplete="off"
                                spellCheck={false}
                                autoCorrect="off"
                                autoCapitalize="off"
                              />
                            </div> */}
                            <div>
                              <label className="form-label fw-semibold">
                                Confirm New Password{" "}
                                <span className="text-danger">*</span>
                              </label>

                              <input
                                type="password"
                                className={`form-control ${
                                  passwordErrors.confirmPassword
                                    ? "is-invalid"
                                    : ""
                                }`}
                                value={passwordData.confirmPassword}
                                onChange={(e) =>
                                  setPasswordData({
                                    ...passwordData,
                                    confirmPassword:  e.target.value.replace(/\s/g, ""),
                                  })
                                }
                                placeholder="Confirm New Password"
                              />

                              {passwordData.confirmPassword &&
                                passwordData.newPassword ===
                                  passwordData.confirmPassword && (
                                  <small className="text-success">
                                    ✓ Passwords match
                                  </small>
                                )}

                              {passwordErrors.confirmPassword && (
                                <div>
                                  <small className="text-danger">
                                    {passwordErrors.confirmPassword}
                                  </small>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          gap: "10px",
                          marginTop: "20px",
                          paddingTop: "15px",
                          borderTop: "1px solid #dee2e6",
                          width: "100%",
                        }}
                      >
                        <button
                          type="button"
                          onClick={changePassword}
                          onMouseEnter={() => setSaveHover(true)}
                          onMouseLeave={() => setSaveHover(false)}
                          style={{
                            backgroundColor: saveHover ? "#157347" : "#198754",
                            color: "#fff",
                            border: "1px solid #198754",
                            padding: "8px 20px",
                            borderRadius: "6px",
                            fontSize: "14px",
                            fontWeight: "500",
                            cursor: "pointer",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            minWidth: "120px",
                            transition: "all 0.2s ease-in-out",
                            boxShadow: saveHover
                              ? "0 4px 8px rgba(25, 135, 84, 0.25)"
                              : "0 2px 4px rgba(0, 0, 0, 0.08)",
                            transform: saveHover
                              ? "translateY(-1px)"
                              : "translateY(0)",
                          }}
                        >
                          Save Changes
                        </button>

                        <button
                          type="button"
                          onClick={onClose}
                          onMouseEnter={() => setCancelHover(true)}
                          onMouseLeave={() => setCancelHover(false)}
                          style={{
                            backgroundColor: cancelHover
                              ? "#5c636a"
                              : "#6c757d",
                            color: "#fff",
                            border: "1px solid #6c757d",
                            padding: "8px 20px",
                            borderRadius: "6px",
                            fontSize: "14px",
                            fontWeight: "500",
                            cursor: "pointer",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            minWidth: "100px",
                            transition: "all 0.2s ease-in-out",
                            boxShadow: cancelHover
                              ? "0 4px 8px rgba(0,0,0,0.15)"
                              : "0 2px 4px rgba(0,0,0,0.08)",
                            transform: cancelHover
                              ? "translateY(-1px)"
                              : "translateY(0)",
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    </>
                  )}

                  {activeTab === "activity" && (
                    <div className="card">
                      <div className="card-body">
                        <h5>Activity Log</h5>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpgradeProfileModal;
